export default function() {
  return {
    notifications: {},
    notificationcount: 0,
    loading: false,
  }
}
